import { NOTIFICATION_TYPES } from "./types";

export function buildDefaultNotificationPrefs() {
  return {
    soundEnabled: true,
    soundOnlyBackground: true,
    desktopEnabled: false,
    categories: {
      [NOTIFICATION_TYPES.chat_message]: true,
      [NOTIFICATION_TYPES.new_request]: true,
      [NOTIFICATION_TYPES.request_assigned]: true,
      [NOTIFICATION_TYPES.response_sla]: true,
      [NOTIFICATION_TYPES.voice_queue]: true,
      [NOTIFICATION_TYPES.voice_call]: true,
      [NOTIFICATION_TYPES.system]: true,
      [NOTIFICATION_TYPES.billing]: true,
      [NOTIFICATION_TYPES.security]: true,
      [NOTIFICATION_TYPES.legacy_socket]: true,
      [NOTIFICATION_TYPES.team_message]: true,
      [NOTIFICATION_TYPES.team_mention]: true,
      [NOTIFICATION_TYPES.agenda_reminder]: true,
      [NOTIFICATION_TYPES.dashboard_report_ready]: true,
      [NOTIFICATION_TYPES.task_due]: true,
      [NOTIFICATION_TYPES.task_overdue]: true,
      [NOTIFICATION_TYPES.task_completed]: true,
      [NOTIFICATION_TYPES.task_board_invite]: true,
      [NOTIFICATION_TYPES.platform_workspace_access]: true,
    },
  };
}

export function normalizePrefsPartial(p) {
  const d = buildDefaultNotificationPrefs();
  if (!p || typeof p !== "object") return d;
  const incomingCats =
    p.categories && typeof p.categories === "object" && !Array.isArray(p.categories)
      ? p.categories
      : {};
  const categories = { ...d.categories, ...incomingCats };
  // Prefs antigas sem voice_queue: herda o toggle de novas solicitações.
  if (!Object.prototype.hasOwnProperty.call(incomingCats, NOTIFICATION_TYPES.voice_queue)) {
    categories[NOTIFICATION_TYPES.voice_queue] = categories[NOTIFICATION_TYPES.new_request] !== false;
  }
  if (!Object.prototype.hasOwnProperty.call(incomingCats, NOTIFICATION_TYPES.voice_call)) {
    categories[NOTIFICATION_TYPES.voice_call] =
      categories[NOTIFICATION_TYPES.voice_queue] !== false;
  }
  return {
    ...d,
    ...p,
    categories,
  };
}

/** @param {unknown} raw coluna JSON / string / objeto da API */
export function parseNotificationPrefsFromApi(raw) {
  if (raw == null || raw === "") return null;
  if (typeof raw === "object" && !Array.isArray(raw)) {
    return normalizePrefsPartial(raw);
  }
  if (typeof raw === "string") {
    try {
      return normalizePrefsPartial(JSON.parse(raw));
    } catch {
      return null;
    }
  }
  return null;
}
